"use client";
import { usePathname } from "next/navigation";
import { Fragment } from "react";
import { Footer } from "@/components/Footer/Footer";
import { GetQuoteSection } from "./MainPage/GetQuoteSection/GetQuoteSection";
import { getBusinessAutomationPagePath, getProjectsPagePath, getServicesPagePath, getTeamPagePath, getBlogPagePath, getHomePagePath } from "@/utils/consts";
export const FooterSection = () => {
    const pathname = usePathname();
    const validPaths = [
        getTeamPagePath(),
        getProjectsPagePath(),
        getServicesPagePath(),
        getBlogPagePath()
    ];

    const isFoundPage = validPaths.some((path) => pathname.startsWith(path));
    const isFoundPageOrMain = isFoundPage || pathname === getHomePagePath();
    const isTeamPage = pathname === getTeamPagePath();
    const isBlogPage = pathname?.includes(getBlogPagePath());
    const isAutomationPage = pathname === getBusinessAutomationPagePath();

    return <Fragment>
        {isFoundPageOrMain && !isBlogPage && !isTeamPage && !isAutomationPage && <GetQuoteSection />}
        <Footer />
    </Fragment>
}
